import type {LocationQueryValue, RouteParamsGeneric} from 'vue-router';

export function unwrapRouteQueryValue(
    queryValue: LocationQueryValue | LocationQueryValue[]
): LocationQueryValue {
    if (queryValue instanceof Array) {
        return queryValue[0];
    }

    return queryValue;
}

export function validateRouteParamAsString(
    routeParams: RouteParamsGeneric,
    paramName: string
): string | null {
    if (paramName in routeParams) {
        const value = routeParams[paramName];
        if (typeof value === 'string') {
            return value;
        }
    }
    return null;
}
